import { Button } from "components/ui/button";
import { useAddMultipleRegionalModal } from "./use-addmultiple-regional-modal";

export function AddMultipleRegionalModal() {
  const { openAddMultipleRegionalModal } = useAddMultipleRegionalModal();

  return (
    <Button className="h-8" onClick={openAddMultipleRegionalModal}>
      Adicionar Regionais
    </Button>
  );
}